import { Component, input, output, model, inject, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormGroup } from '@angular/forms';
import { RoleService } from '../../services/role.service';
import Swal from 'sweetalert2';
import { FormMode } from 'app/core/constants/form-mode';
import { PermissionService } from '@services/core/permission.service';

@Component({
    selector: 'app-role-form',
    standalone: true,
    imports: [CommonModule, ReactiveFormsModule],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './role-form.component.html'
})
export class RoleFormComponent {

    roleForm = input.required<FormGroup>();
    formChange = output<FormGroup | null>();
    mode = model<FormMode>(FormMode.CREATE);
    formMode = FormMode;

    private roleService = inject(RoleService);
    readonly perm = inject(PermissionService);

    constructor() { }

    categoryLabel(value: string | null | undefined): string {
        const map: Record<string, string> = {
            USER: 'Usuario / Socio',
            FINANZAS: 'Finanzas',
            SECRETARIA: 'Secretaría',
            ADMINISTRACION: 'Administración'
        };
        return map[String(value || '').toUpperCase()] || 'Sin categoría';
    }

    /** Fuerza slug en mayúsculas al escribir. */
    onNameInput(event: Event) {
        const el = event.target as HTMLInputElement;
        const slug = String(el.value || '')
            .toUpperCase()
            .replace(/\s+/g, '_')
            .replace(/[^A-Z0-9_]/g, '');
        if (el.value !== slug) el.value = slug;
        this.roleForm().get('name')?.setValue(slug, { emitEvent: false });
    }

    submit() {
        if (this.roleForm() && this.roleForm().valid) {
            this.formChange.emit(this.roleForm());
        }
    }

    editMode() {
        this.mode.set(this.formMode.EDIT);
    }

    updateStatus(isActive: boolean) {
        const id = this.roleForm().get('id')?.value;
        const action = isActive ? 'habilitar' : 'desactivar';
        Swal.fire({
            title: `¿Estás seguro de ${action} este rol?`,
            text: "No podrás revertir esto",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            cancelButtonText: 'Cancelar',
            confirmButtonText: `Sí, ${action}`
        }).then((result) => {
            if (result.isConfirmed) {
                this.roleService.update(id, { isActive: isActive }).subscribe({
                    next: () => {
                        Swal.fire({
                            toast: true,
                            position: 'top-end',
                            showConfirmButton: false,
                            timer: 3000,
                            timerProgressBar: true,
                            icon: 'success',
                            title: `El rol ha sido ${action}ado`
                        });
                        this.formChange.emit(null);
                    },
                    error: () => Swal.fire('Error', `No se pudo ${action} el rol`, 'error')
                });
            }
        });
    }
}
